import { useRecordContext, useRefresh, useNotify } from 'react-admin'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import AssignAgentButton from '../ViewAgentsPanel/AssignAgentButton'
import { assignAgentToLead } from '../../../../Utils/RestUtils'
import { autoSaveField } from '../../../../Utils/AutoSave'
import { scrollToPanelById } from '../../../../Utils/QuoteRequestUtils'
import { usePriceModalContext } from '../../../../Utils/providers/PriceModalProvider'

const ScrapModal = () => {
  const record = useRecordContext()
  const refresh = useRefresh()
  const notify = useNotify()
  const { activeModal, modalPayload, closeModal } = usePriceModalContext()

  // NOTE - this modal does not open without agent so it is safe to assume it exists
  if (!modalPayload?.agent) return null

  const agent = modalPayload.agent

  // NOTE - this is a copy of function inside `ListAgents`, maybe refactor
  const handleAssignAgent = async (agent) => {
    try {
      const response = await assignAgentToLead({
        quoteRequestId: record['@id'],
        agentId: agent.agent_id,
        offerId: agent.offer_id,
        agentInfo: agent.company_name,
        pageLeft: agent.car_offer_page_left,
        commission: agent.commission,
        donation: agent.donation ?? 0,
        collectorPrice: agent.price,
        customerPrice: agent.sort_price,
      })

      if (response.result !== 'success') {
        throw new Error(response.error_msg || 'Failed to assign agent')
      }

      refresh()
      scrollToPanelById('bookingsPanel')

      // Set Offer Journey Followed to true
      await autoSaveField({
        fields: [
          {
            classToInitialize: null,
            method: 'setOfferJourneyFollowed',
            quoteRequestId: record['@id'],
            value: true,
          },
        ],
        iri: record.leadContact.vehicle.vehicleSalvage['@id'],
      })
    } catch (error) {
      notify(
        error?.message || 'An unexpected error occurred while assigning agent',
        { type: 'error' }
      )
    }
  }

  return (
    <Dialog
      disablebackdropclick="true"
      disableEnforceFocus
      hideBackdrop
      disableScrollLock
      fullWidth
      open={activeModal === 'scrap'}
      onClose={closeModal}
      aria-label="Get scrap price modal"
      sx={{
        left: '50%',
        top: '50%',
        right: 'initial',
        bottom: 'initial',
        transform: 'translate(-50%, -50%)',
        maxWidth: '768px',
        width: '100%',
      }}
      PaperProps={{
        sx: {
          padding: 2,
        },
      }}
    >
      <DialogContent sx={{ padding: 0 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography variant="h6" fontWeight={'bold'}>
                Top scrap offer
              </Typography>
              <Typography>
                This lead will be automatically converted to scrap due to the
                offer price being lower than the scrap value
              </Typography>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Collector Name</TableCell>
                      <TableCell>Customer price</TableCell>
                      <TableCell>Commission</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>{agent.company_name}</TableCell>
                      <TableCell>£{agent.customer_price}</TableCell>
                      <TableCell>£{agent.commission}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
          <Grid item xs={12}></Grid>
        </Grid>
        <Divider sx={{ my: 2 }} />
        <DialogActions sx={{ padding: 0 }}>
          <Button label="ra.action.cancel" onClick={closeModal}>
            Cancel
          </Button>
          <AssignAgentButton
            handleAssignAgent={() => handleAssignAgent(agent)}
          />
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}

export default ScrapModal
